var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 py-0 d-sm-none"},[_c('a',{staticClass:"collapsed",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.openSidebar()}}},[_c('i',{staticClass:"fas fa-bars fa-2x"})])])}
var staticRenderFns = []

export { render, staticRenderFns }